import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const GmailCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    
    if (code && window.opener) {
      // Send the code back to the parent window
      window.opener.postMessage({ type: 'GMAIL_AUTH_SUCCESS', code }, '*');
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="text-nextide-turquoise text-xl mb-2">Connecting Gmail...</div>
        <div className="text-zinc-400">You can close this window if it doesn't close automatically.</div>
      </div>
    </div>
  );
};

export default GmailCallback;
